import React,{useEffect,useRef} from "react";
import img6 from "../assets/note.svg"
import img7 from "../assets/tick-square.svg"
import img8 from "../assets/award.svg"
import img9 from "../assets/building.svg"
import WhiteCard from "./WhiteCard";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const HomeSec2 = ()=>{
    const Title = useRef(null);
    const sub = useRef(null);
    const button = useRef(null);
    // const button2 = useRef(null);
    const s1 = useRef(null);
    // const s2 = useRef(null);
    // const s3 = useRef(null);
    // const s4 = useRef(null);

    useEffect(() => {
    gsap.set(Title.current, { opacity: 0, y: 100 });
    gsap.set(sub.current, { opacity: 0, y: 100 });
    gsap.set(s1.current, { opacity: 0, y: 100 });
    gsap.set(button.current, { opacity: 0, y: 100 });

    // Title Animation
    gsap.to(Title.current, {
        opacity: 1,
        y: 0,
        duration: 2,
        scrollTrigger: {
          trigger: Title.current,
          start: "top 100%",
          end: "bottom top",
          toggleActions: "play none none reverse",
        },
      });
    // sub Animation
    gsap.to(sub.current, {
        opacity: 1,
        y: 0,
        duration: 2,
        scrollTrigger: {
          trigger: sub.current,
          start: "top 100%",
          end: "bottom top",
          toggleActions: "play none none none",
        },
      });
    // sub Animation
    gsap.to(s1.current, {
        opacity: 1,
        y: 0,
        duration: 2,
        scrollTrigger: {
          trigger: s1.current,
          start: "top 100%",
          end: "bottom top",
          toggleActions: "play none none none",
        },
      });
    // sub Animation
    gsap.to(button.current, {
        opacity: 1,
        y: 0,
        duration: 2,
        scrollTrigger: {
          trigger: button.current,
          start: "top 100%",
          end: "bottom top",
          toggleActions: "play none none none",
        },
      });


    }, []);
    return(
        <>
            {/* Section 2 */}
            <section className="bg-black md:pt-14 xl:pt-32 font-guton border-none">
                <div className="w-90 mx-auto pb-10 max-w-[1440px]">
                    <div className="flex flex-col mt-8 mb-4">
                        <h2 ref={Title} className="text-30 leading-24 text-center md:text-start md:text-36 md:leading-30 text-white font-medium lg:text-55 lg:leading-55 xl:text-64 xl:leading-55 tracking-[-2px]">Your Complete <br />Study Abroad Partner</h2>
                        <p ref={sub} className="text-center md:w-full mx-auto md:text-start text-grey my-2 xl:my-5 text-16 leading-16 xl:leading-24 w-65 md:text-18 lg:text-28 xl:text-32 tracking-[-1px]">From Application to Relocation: We’ve Got You Covered</p>
                    </div>
                    <div ref={s1} className="grid grid-cols-2 gap-4 md:gap-1 md:flex md:justify-between md:mt-8 xl:mt-14 mb-8 md:space-x-6">
                        {/* Card 1 */}
                        <div className="flex flex-col w-full md:w-45 items-center text-center md:text-left">
                            <div className="flex bg-custom-gradient rounded-md w-12 h-12 md:w-12 md:h-12 xl:w-20 xl:h-20 justify-center md:self-start">
                                <img className="w-4/6" src={img6} alt="" />
                            </div>
                            <p className="text-16 w-55 md:w-auto md:text-20 leading-14 md:leading-21 xl:text-36 xl:leading-36 font-medium text-white mb-2 mt-3 md:my-3 xl:my-6">
                                University Applications
                            </p>
                            <p className="text-12 leading-10 md:text-16 md:leading-16 xl:text-26 xl:leading-28 tracking-[-0.8px] text-white">
                                Matching you with universities based on your goals and budget.
                            </p>
                        </div>
                        
                        {/* Card 2 */}
                        <div className="flex flex-col w-full md:w-45 items-center text-center md:text-left">
                            <div className="flex bg-custom-gradient rounded-md w-12 h-12 md:w-12 md:h-12 xl:w-20 xl:h-20 justify-center md:self-start">
                                <img className="w-4/6" src={img7} alt="" />
                            </div>
                            <p className="text-16 w-70 md:w-auto md:text-20 leading-14 md:leading-21 xl:text-36 xl:leading-36 font-medium text-white mb-2 mt-3 md:my-3 xl:my-6">
                                Step-by-Step Visa Guidance
                            </p>
                            <p className="text-12 leading-10 md:text-16 md:leading-16 xl:text-26 xl:leading-28 tracking-[-0.8px] text-white">
                                Clear, easy-to-follow process to secure your visa.
                            </p>
                        </div>
                        
                        {/* Card 3 */}
                        <div className="flex flex-col w-full md:w-45 items-center text-center md:text-left">
                            <div className="flex bg-custom-gradient rounded-md w-12 h-12 md:w-12 md:h-12 xl:w-20 xl:h-20 justify-center md:self-start">
                                <img className="w-4/6" src={img8} alt="" />
                            </div>
                            <p className="text-16 leading-14 w-55 md:w-auto md:text-20 md:leading-21 xl:text-36 xl:leading-36 font-medium text-white mb-2 mt-3 md:my-3 xl:my-6">
                                Scholarships Support
                            </p>
                            <p className="text-12 leading-10 md:text-16 md:leading-16 xl:text-26 xl:leading-28 tracking-[-0.8px] text-white">
                                Guiding you in identifying and applying for scholarships and grants.
                            </p>
                        </div>
                        
                        {/* Card 4 */}
                        <div className="flex flex-col w-full md:w-45 items-center text-center md:text-left">
                            <div className="flex bg-custom-gradient rounded-md w-12 h-12 md:w-12 md:h-12 xl:w-20 xl:h-20 justify-center md:self-start">
                                <img className="w-4/6" src={img9} alt="" />
                            </div>
                            <p className="text-16 leading-14 md:text-20 md:leading-21 xl:text-36 xl:leading-36 font-medium text-white mb-2 mt-3 md:my-3 xl:my-6">
                                Accommodation Assistance
                            </p>
                            <p className="text-12 leading-10 md:text-16 md:leading-16 xl:text-26 xl:leading-28 tracking-[-0.8px] text-white">
                                Helping you find safe and affordable housing near universities.
                            </p>
                        </div>
                    </div>
                    {/* apply buttons */}
                    <div ref={button} className="flex justify-center md:justify-start w-content space-x-2 md:space-x-2 text-14 md:text-14 xl:text-24 md:mt-7 mb-12 xl:my-16">    
                        <a href="https://wa.link/eaoxxu" target="_blank" rel="noopener noreferrer" className="flex font-guton font-semibold bg-custom-gradient text-white px-4 md:px-6 xl:px-14 rounded-full py-2 md:py-2 xl:py-3 leading-12 xl:leading-30 hover:text-black hover:bg-custom-white transition duration-500 ease-in-out">Apply Now</a>
                        <a href="/services" className="flex font-guton font-semibold bg-white text-black px-3 md:px-6 xl:px-10 rounded-full py-2 md:py-2 xl:py-3 leading-12 xl:leading-30 hover:text-white hover:bg-custom-gradient transition duration-500 ease-in-out">Know More?</a>
                    </div>
                    
                    <WhiteCard />

                </div>
            </section>
        </>
    )
}

export default HomeSec2;